module.exports = __webpack_public_path__ + "static/media/logospin.58fbea3f.png";